module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00635.fe73b17f.jpg";